// import React, { useEffect, useState } from 'react';
// import { Navigate } from 'react-router-dom';

// const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

//   useEffect(() => {
//     fetch('/dashboard', { credentials: 'include' })
//       .then(res => setIsAuthenticated(res.ok))
//       .catch(() => setIsAuthenticated(false));
//   }, []);

//   if (isAuthenticated === null) return <div>Loading...</div>;

//   return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
// };

// export default ProtectedRoute;


import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

axios.defaults.withCredentials = true;

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const api = process.env.REACT_APP_API_URL as string;
  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const response = await axios.get(`${api}/auth/admindashboard`);
        //console.log('Dashboard API response:', response.data);

        if (response.status !== 200 || !response.data.role) {
          setIsAuthorized(false);
          return;
        }

        setIsAuthorized(response.data.role === 'super-admin');
      } catch (error) {
        if (axios.isAxiosError(error)) {
          console.error('Axios error:', error.response?.data || error.message);
        } else {
          console.error('Unexpected error:', error);
        }
        setIsAuthorized(false);
      }
    };

    checkAuthorization();
  }, []);

  if (isAuthorized === null) return <div>Loading...</div>;

  return isAuthorized ? <>{children}</> : <Navigate to="/login" />;
};

export default ProtectedRoute;
